(function (upp) {
    'use strict';

    /**
     * @typedef {object} CustomerField
     * @property {number}               id - Unique identifier for the field
     * @property {CustomerFieldType}  type - Type of the field, represents what kind of data it can hold
     * @property {string}             name - Name identing the field
     * @property {boolean}        required - Determines if this field is always required to be filled or can be left blank
     */

    /**
     * @typedef {object} CustomerFieldValue
     * @property {number} id - Unique identifier of the field this value belongs to
     * @property {string} value - Value of the field
     * @property {numbre} optionSelected - Only if the field this is of type OPTIONS, the id of the selected option.
     */

    /**
     * @typedef {object} UserInfo
     * @property {string} email
     * @property {string} password
     * @property {string} name
     * @property {string} surname
     * @property {CustomerFieldValue[]} fields
     */

    CustomerAccountApiService.$inject = [ 'appi', 'accountManagerService' ];
    function CustomerAccountApiService(appi, accountManagerService) {
        Object.defineProperties(this, {
            appi: { value: appi },
            accountManagerService: { value: accountManagerService },
        });
    }

    /**
     * Retrieves the customer field list for the current childupp.
     * @return {Promise<CustomerField[]>}
     */
    CustomerAccountApiService.prototype.getFields = function() {
        return this.appi.http
        .getSecure($UPP.URL_UPPLICATION_REST_SERVICE + 'app/customer-fields/')
        // Return only the fields from the response body
        .then(function(res) { return res.data.fields })
    }

    /**
     * Retrieves the current logged user information. If no user is currently logged in,
     * said information will be `null`
     * @return {Promise<UserInfo>}
     */
    CustomerAccountApiService.prototype.getUserInfo = function() {
        return this.appi.security.getAuthentication()
            .then(function(auth) {
                if (auth.type !== 'anonymous')
                    return this.accountManagerService.retrieve();
                else
                    return undefined;
            }.bind(this))
            .then(function(res) {
                if (res && res.data && typeof res.data === 'object')
                    return res.data;
                else
                    return null
            })
            .catch(function() { return null })
    }

    upp
    .service('customerAccountApiService', CustomerAccountApiService)
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/customer-account/services/customer-account-api.service.js